/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/sub-pages/OverviewSubPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const OverviewSubPageTestIds = {
  btnSyncDelta: "btn-sync-delta",
  btnSyncFull: "btn-sync-full",
  btnSyncPreview: "btn-sync-preview",
  cardTitleManualSync: "card-title-manual-sync",
  connectorInfoCard: "connector-info-card",
  lastSyncCard: "last-sync-card",
  manualSyncCard: "manual-sync-card",
  scheduleCard: "schedule-card",
  syncConfirmDialog: "sync-confirm-dialog",
  targetSystemLink: "target-system-link"
} as const;
